<template>
    <div class="question-item" v-if="show !== false">
        <div class="question-title">
            <span>{{ question.indexNo }}. </span>
            <template v-for="(item, index) in titleList">
                <TextTemplate class="title-item" v-if="item.type === 'text'" :key="index" :text="item.title" />
                <div v-else-if="item.type === 'input'" :key="`index-${index}`" class="blank">
                    <span v-if="question.type === 'ORDER_BLANK' && blankNum > 1" class="index">
                        {{ item.index + 1 }}
                    </span>
                    <input
                        @change="onChange"
                        placeholder="请输入"
                        v-model.trim="answerList[item.index]"
                        :style="`width: ${item.width}px`"
                    />
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { getQuestionBlankConfig } from '@/utils/tools.js'
import TextTemplate from '../../TextTemplate.vue'

export default {
    components: { TextTemplate },
    props: ['show', 'question'],
    data() {
        return {
            titleList: [],
            answerList: null,
            blankNum: 0,
        }
    },
    created() {
        const list = []
        // TODO 填空题格式兼容
        if (this.question.content.indexOf('_____') > -1) {
            this.question.content.split('_____').forEach((str, i) => {
                list.push({ type: 'text', title: str })
                list.push({ type: 'input', index: i })
            })
        } else {
            const blankConfg = getQuestionBlankConfig(this.question.content || '')
            this.question.content.split(/BLANK__\d+/).forEach((str, i) => {
                list.push({ type: 'text', title: str })
                list.push({ type: 'input', index: i, width: blankConfg[i] })
            })
        }
        list.pop()
        list.forEach((i) => {
            if (i.type === 'input') {
                this.blankNum += 1
            }
        })
        this.titleList = list
        this.answerList = new Array(this.question.childCnt)
        if (this.question.stashAnswer) {
            this.answerList = this.question.stashAnswer
        }
        this.updateStoreData()
    },
    methods: {
        onChange() {
            this.updateStoreData('edit')
        },
        updateStoreData(type) {
            const { id } = this.question
            // unfinishNum = this.answerList.length 无作答
            // unfinishNum = 0 已作答
            // unfinishNum > 0 未完成
            let unfinishNum = 0
            for (let index = 0; index < this.answerList.length; index++) {
                if (!this.answerList[index]) unfinishNum += 1
            }

            if (type === 'edit') {
                this.$store.dispatch('paperDetails/updateUserAnswer', {
                    id,
                    answer: unfinishNum !== this.answerList.length ? this.answerList : [],
                })
            }

            let data = null
            if (unfinishNum !== this.answerList.length) {
                data = { state: unfinishNum === 0, answer: this.answerList }
            }
            this.$store.dispatch('paperDetails/setUserAnswerMap', { [`q-${id}`]: data })
        },
    },
}
</script>
<style lang="scss" scoped>
.question-title {
    line-height: 36px;
    .title-item {
        display: inline;
    }
    .blank {
        display: inline-block;
        position: relative;
        padding: 0 4px;
        .index {
            width: 16px;
            height: 16px;
            color: #ff8c00;
            border: 1px solid #ff8c00;
            font-size: 12px;
            border-radius: 20px;
            display: inline-block;
            text-align: center;
            line-height: 16px;
        }
        input {
            border: none;
            border-bottom: 1px solid #ccc;
            width: 80px;
            min-width: 80px;
            margin: 0 8px;
            padding: 2px 4px;
            height: 22px;
            line-height: 1em;
            vertical-align: middle;
            background: none;
            border-radius: 0;
            &:focus {
                border-bottom: 1px solid #ff8c00;
            }
            &:disabled {
                cursor: not-allowed;
            }
        }
    }
}
</style>
